
























































































































































































/* eslint-disable @typescript-eslint/camelcase */
import {Component, Mixins, Ref, Watch} from "vue-property-decorator";
import EmployeeMixin from "@/mixins/employee";
import {Api} from "shared/api";
import {faHome} from "@fortawesome/free-solid-svg-icons";
import OpenerMixin from "@/mixins/opener";
import {GenerateSpectacleRequest} from "shared/api/requests/generateFileRequest";
import {DateTime} from "luxon";
import CustomDropdown, {CustomDropdownValue} from "@/components/CustomDropdown.vue";

@Component({
    components: {CustomDropdown}
})
export default class Spectacle extends Mixins(EmployeeMixin, OpenerMixin) {
    constructor() {
        super();
        this.resetForm();
        for (let i = 20; i >= -20; i -= 0.25) {
            if (i === 0) {
                this.sphereSizes.push("Plano");
                this.sphereSizes.push("");
            } else if (i > 0) {
                this.sphereSizes.push("+" + i.toFixed(2));
            } else {
                this.sphereSizes.push(i.toFixed(2));
            }
        }

        for (let i = -0.25; i >= -8; i -= 0.25) {
            this.cylinderSizes.push(i.toFixed(2));
        }
        for (let i = 6; i >= 0.25; i -= 0.25) {
            this.addSizes.push("+" + i.toFixed(2));
        }
        this.addSizes.push("");

        for (let i = 1; i <= 6; i++)
            for (const s of ["Up", "Down"])
                this.prismUpDownSizes.push(`${i} ${s}`);

        for (let i = 1; i <= 6; i++)
            for (const s of ["In", "Out"])
                this.prismInOutSizes.push(`${i} ${s}`);
    }

    public icons = {
        faHome,
    }

    public manuallySetExpiration = false;
    public sphereSizes: string[] = [];
    public cylinderSizes: string[] = [""];
    public addSizes: string[] = [];
    public prismInOutSizes: string[] = [""];
    public prismUpDownSizes: string[] = [""];
    public prismSelections = {
        odInOut: "",
        odUpDown: "",
        osInOut: "",
        osUpDown: "",
    }

    public customDropdowns = {
        OD_Add: new CustomDropdownValue<string>(""),
        OS_Add: new CustomDropdownValue<string>(""),
    }

    public form!: GenerateSpectacleRequest;

    @Ref("htmlForm") htmlForm!: HTMLFormElement;

    private async mounted() {
        if (!await this.authorized()) {
            await this.$router.push({name: "Login"});
        }
    }

    @Watch("customDropdowns.OD_Add.value")
    private updateODAddValue() {
        this.form.OD_Add = this.customDropdowns.OD_Add.value || "";
    }

    @Watch("customDropdowns.OS_Add.value")
    private updateOSAddValue() {
        this.form.OS_Add = this.customDropdowns.OS_Add.value || "";
    }

    private async onExamDateSet() {
        if (!this.manuallySetExpiration) {
            this.setExpirationDate();
        }
    }

    private setPrism() {
        this.form.OS_Prism = [this.prismSelections.osInOut, this.prismSelections.osUpDown].filter(t => t !== "").join(", ");
        this.form.OD_Prism = [this.prismSelections.odInOut, this.prismSelections.odUpDown].filter(t => t !== "").join(", ");;

    }

    private setExpirationDate() {
        this.form.Expiration_Date = DateTime.fromISO(this.form.Exam_Date).plus({years: 1}).toISODate();
        this.$forceUpdate();
    }

    async submit() {
        const win = this.createWindow();
        const result = await Api.generate.Spectacle.Post(this.form);
        if (result.success) {
            win.setUrl(Api.generate.File._uri + `?file=${result.result.file}`);
        } else {
            alert("Something went wrong. Please try again. If the problem persist, contact Support at (248) 545-0800");
        }
    }

    private resetForm() {
        this.form = {
            company: "",
            Patient_Name: "",
            Date_of_Birth: "",
            Exam_Date: DateTime.local().toISODate(),
            Expiration_Date: DateTime.local().plus({years: 1}).toISODate(),
            OD_Sphere: "",
            OS_Sphere: "",
            OD_Cylinder: "",
            OS_Cylinder: "",
            OD_Axis: "",
            OS_Axis: "",
            OD_Prism: "",
            OS_Prism: "",
            OD_Add: "",
            OS_Add: "",
            Check_Varulix_Digital: "",
            Check_Thin: "",
            Check_Varulix_Eyezen: "",
            Check_Varulix_Eyezen_Number: "",
            Check_Polarized: "",
            Check_Crizal: "",
            Check_Computer: "",
            Check_Blue: "",
            Check_UV: "",
            Check_Transition: "",
            Check_Scratch: "",
        };
        this.setExpirationDate();
    }
}
